import { Reveal } from "./Reveal";
import { PHOTO_SIZES, PHOTOS, type Photo } from "./images";

const ITEMS: { photo: Photo; span: string; ratio: string; sizes: string }[] = [
  {
    photo: PHOTOS.rvSite,
    span: "sm:col-span-7",
    ratio: "aspect-[16/11]",
    sizes: PHOTO_SIZES.galleryWide,
  },
  {
    photo: PHOTOS.clubhouse,
    span: "sm:col-span-5",
    ratio: "aspect-[16/11] sm:aspect-[4/5]",
    sizes: PHOTO_SIZES.galleryNarrow,
  },
  {
    photo: PHOTOS.parkModelPatio,
    span: "sm:col-span-5",
    ratio: "aspect-[4/3]",
    sizes: PHOTO_SIZES.galleryNarrow,
  },
  {
    photo: PHOTOS.cabinRow,
    span: "sm:col-span-7",
    ratio: "aspect-[16/9]",
    sizes: PHOTO_SIZES.galleryWide,
  },
  {
    photo: PHOTOS.parkModelCarport,
    span: "sm:col-span-4",
    ratio: "aspect-[4/3]",
    sizes: PHOTO_SIZES.galleryThird,
  },
  {
    photo: PHOTOS.coveredParking,
    span: "sm:col-span-4",
    ratio: "aspect-[4/3]",
    sizes: PHOTO_SIZES.galleryThird,
  },
  {
    photo: PHOTOS.sign,
    span: "sm:col-span-4",
    ratio: "aspect-[4/3]",
    sizes: PHOTO_SIZES.galleryThird,
  },
];

export function PropertyGallery() {
  return (
    <section className="bg-surface py-24 sm:py-28 lg:py-32" aria-labelledby="gallery-title">
      <div className="mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-10">
        <Reveal className="flex flex-wrap items-end justify-between gap-6">
          <div className="max-w-xl">
            <p className="eyebrow text-clay">The Property</p>
            <h2
              id="gallery-title"
              className="mt-4 font-display text-3xl leading-tight sm:text-4xl lg:text-[2.9rem]"
            >
              A Look Around Amigo Inn
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-muted-foreground">
            Real photographs of the sites, park models, clubhouse and covered spaces you will find
            when you pull in off U.S. Hwy 83.
          </p>
        </Reveal>

        <ul className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-12">
          {ITEMS.map((item, i) => (
            <Reveal
              as="li"
              key={`${item.photo.alt}-${i}`}
              delay={(i % 3) * 0.07}
              className={item.span}
            >
              <figure className="media-zoom rounded-sm">
                <img
                  src={item.photo.src}
                  srcSet={item.photo.srcSet}
                  sizes={item.sizes}
                  alt={item.photo.alt}
                  width={item.photo.width}
                  height={item.photo.height}
                  loading="lazy"
                  decoding="async"
                  className={`w-full rounded-sm object-cover ${item.ratio}`}
                />
              </figure>
            </Reveal>
          ))}
        </ul>
      </div>
    </section>
  );
}
